import { defineMessages } from 'react-intl';

const _default_1: {
	saveRelease: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	saveRelease: {
		id: 'ai-mate.message-actions.jira-version-create.jira-version-create-form-footer.saveRelease',
		defaultMessage: 'Create release',
		description:
			'Text shown on the primary submit button in the form footer of the create release modal in Rovo chat, which saves and creates the new Jira release.',
	},
});
export default _default_1;
